// Lib
import { SIZE_FULL } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

// Components
import { SimpleBarChartComponent } from '@/components/composite/Charts/SimpleBarChart';

export const postClicksDistributionConfig = {
    title: 'chart.facebook.post_clicks_distribution',
    icon: 'click',
    id: 'post_clicks_distribution',
    tickFormatterTranslation: 'analytics:chart.post_clicks',
    noLegend: false,
    margin: {
        left: -40
    },
    name: {
        type: 'chart.facebook.post_clicks_distribution_type',
        value: 'chart.facebook.post_clicks_distribution_value'
    },
    social: FACEBOOK,
    valueFormat: classicFormat,
    color: {
        value: 'blue'
    },
    barSize: 56,
    barRadius: 12,
    size: SIZE_FULL,
    type: 'chart',
    element: SimpleBarChartComponent
};
